import React from "react";
import { Label } from "@/components/ui/label";
import { Image as ImageIcon, X } from "lucide-react";

const FieldIcon = ({ icon: Icon }) => (
  <Icon className="w-3.5 h-3.5 text-slate-500 mr-1.5 inline-block align-[-2px]" strokeWidth={1.5} />
);

// Read-only grid of images from a property's `gallery`, with per-image
// remove button. Renders nothing when the list is empty.
const GalleryGrid = ({ images = [], onRemove }) => {
  if (!images || images.length === 0) return null;
  return (
    <div className="border-t border-slate-200 pt-4 mt-2" data-testid="pd-gallery">
      <Label className="text-xs uppercase tracking-wider"><FieldIcon icon={ImageIcon} />Galleria ({images.length})</Label>
      <div className="grid grid-cols-4 md:grid-cols-6 gap-2 mt-2">
        {images.map((img, i) => {
          // Data-URLs are the actual identity of a gallery entry — use a
          // stable slice as key so React preserves DOM/state when the
          // user re-orders or removes items. Falls back to index for
          // exotic sources without a stable prefix.
          const key = typeof img === "string" && img.length > 24
            ? `${img.slice(0, 24)}:${img.length}:${i}`
            : `gallery-${i}`;
          return (
            <div key={key} className="relative group aspect-square rounded-lg overflow-hidden border border-slate-200 bg-slate-100" data-testid={`pd-gallery-${i}`}>
            <img src={img} alt={`Foto ${i + 1}`} className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => onRemove?.(i)}
              className="absolute top-1 right-1 w-6 h-6 rounded-full bg-white/90 shadow-sm flex items-center justify-center text-slate-600 hover:text-rose-600 opacity-0 group-hover:opacity-100 transition-opacity"
              data-testid={`pd-gallery-remove-${i}`}
              aria-label="Rimuovi foto"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
          );
        })}
      </div>
    </div>
  );
};

export default GalleryGrid;
